import React from 'react';
import { Card } from 'ui-toolkit';
import 'ui-toolkit/scss/modules/_ordered-items.scss';
import { IAddRowAction } from './AddRowActions';
import { TotalCosts } from './Items/TotalCosts';
import Section from './Section';
import { ITotals } from '../../ui-toolkit/cdItems/interfaces/ITotals';
import { IGroupTotals } from '../../ui-toolkit/cdItems/interfaces/IGroupTotals';

export interface ILoanCosts {
  showSeller: boolean;
  originationActions: IAddRowAction[];
  originationContent?: React.ReactNode;
  originationTotals?: ITotals | null;
  notShoppedForActions: IAddRowAction[];
  notShoppedForContent?: React.ReactNode;
  notShoppedForTotals?: ITotals | null;
  shoppedForActions: IAddRowAction[];
  shoppedForContent: React.ReactNode;
  shoppedForTotals?: ITotals | null;
  totalLoanCosts: IGroupTotals;
  hasEditPermissions?: boolean;
}

export default class LoanCosts extends React.Component<ILoanCosts> {
  public render() {
    const {
      originationActions,
      originationContent,
      originationTotals,
      notShoppedForActions,
      notShoppedForContent,
      notShoppedForTotals,
      shoppedForActions,
      shoppedForContent,
      shoppedForTotals,
      showSeller,
      totalLoanCosts,
      hasEditPermissions,
    } = this.props;
    const { subtotals } = totalLoanCosts;
    return (
      <Card className="loan-costs ordered-items ordered-items--letters" title="Loan Costs">
        <Section
          name="A. Origination Charges"
          data-test-id={'origination-charges'}
          showSeller={showSeller}
          addRowActions={originationActions}
          totals={originationTotals}
          hasEditPermissions={hasEditPermissions}
        >
          {originationContent}
        </Section>
        <Section
          data-test-id={`services-not-shopped-for`}
          name={`B. Services ${showSeller ? 'Buyer' : 'Borrower'} did not shop for`}
          showSeller={showSeller}
          addRowActions={notShoppedForActions}
          totals={notShoppedForTotals}
          hasEditPermissions={hasEditPermissions}
        >
          {notShoppedForContent}
        </Section>
        <Section
          data-test-id={`services-shopped-for`}
          name={`C. Services ${showSeller ? 'Buyer' : 'Borrower'} did shop for`}
          showSeller={showSeller}
          addRowActions={shoppedForActions}
          totals={shoppedForTotals}
          hasEditPermissions={hasEditPermissions}
        >
          {shoppedForContent}
        </Section>
        <Section
          name="D. Total loan costs"
          showSeller={showSeller}
          showLenderPaid={false}
          showNettedOut={false}
          totals={subtotals}
        >
          <TotalCosts
            showSeller={showSeller}
            text="Loan costs subtotals (A+B+C)"
            buyerClosingTotal={subtotals.buyer_at_closing}
            buyerBeforeTotal={subtotals.buyer_before_closing}
            sellerClosingTotal={subtotals.seller_at_closing}
            sellerBeforeTotal={subtotals.seller_before_closing}
            othersTotal={subtotals.paid_by_others}
          />
        </Section>
      </Card>
    );
  }
}
